import { memo } from "react"
import { Paper, Typography, Stack, Button, Box } from "@mui/material"

const NodeSkillsGroups = ({ skills, groups, handleSkillGroupClick, t }) => {
  return (
    <Paper
      elevation={3}
      sx={{
        minHeight: 200,
        height: 200,
        overflowY: "scroll",
        p: 2,
        borderRadius: "0.3rem",
        transition: "all 0.3s ease",
      }}
    >
      <Typography variant='h6' color='primary' gutterBottom>
        {t("Skills")}
      </Typography>

      <Box sx={{ minHeight: 50 }}>
        <Stack spacing={1} direction='row' flexWrap='wrap' useFlexGap>
          {skills.map(
            (skill, i) =>
              skill?.duration !== "demand" && (
                <Button
                  key={i}
                  variant='outlined'
                  onClick={() => handleSkillGroupClick(skill)}
                  sx={{
                    color: "primary.main",
                    borderColor: "primary.main",
                    textTransform: "none",
                    ":hover": {
                      backgroundColor: "primary.light",
                      color: "text.primary",
                    },
                  }}
                >
                  {skill.name}
                </Button>
              )
          )}
        </Stack>
      </Box>

      <Typography variant='h6' sx={{ mt: 3 }} color='secondary' gutterBottom>
        {t("Groups")}
      </Typography>

      <Box sx={{ minHeight: 50 }}>
        <Stack spacing={1} direction='row' flexWrap='wrap' useFlexGap>
          {groups.map((group, i) => (
            <Button
              key={i}
              variant='outlined'
              onClick={() => handleSkillGroupClick(group)}
              sx={{
                color: "secondary.main",
                borderColor: "secondary.main",
                textTransform: "none",
                ":hover": {
                  backgroundColor: "secondary.light",
                  color: "text.primary",
                },
              }}
            >
              {group.name}
            </Button>
          ))}
        </Stack>
      </Box>
    </Paper>
  )
}

export default memo(NodeSkillsGroups)
